import clsx from 'clsx';

export interface ScoreHealthRangeContainerProps {
  className?: string;
  children?: React.ReactNode;
}

export function ScoreHealthRangeContainer({ children, className }: ScoreHealthRangeContainerProps) {
  return <div className={clsx(className, 'flex flex-col items-center relative')}>{children}</div>;
}
